<template>

	<!-- Default footer -->
	<footer class="flex-sup limiter-holder" id="footer_root">
	<div class="flex-sup limiter-wrapper delivers_wrapper">
			<footer class="flex-sup defaultGlobalFooter">
			<p>
					© {{ new Date().getFullYear() }} DNC.Group - Todos os direitos reservados. | DTC Treinamentos & Consultoria LTDA | CNPJ: 27.995.577/0001-37 | R. Justino Cobra, 61 - Vila Ema | São José dos Campos - SP | CEP 12243-030
			</p>
			</footer>
	</div>
	</footer>

</template>

<style scoped>

	.defaultGlobalFooter p {font: .8em gotham-bo; font-weight: 400;}

</style>

<script>

export default {
  name: 'Footer'
}




</script>
